export default __webpack_public_path__ + "static/media/trusted-5.850f8050.webp";